<div class="d-flex align-items-center ace-pagination">

  @if (showTotalCount) {
    <div class="d-none d-sm-block page-count">
      {{ count }} {{ 'total' | messageTranslate }}
    </div>
  }

  @if (showPageSizeSelect) {
    <div class="d-none d-sm-block ms-auto me-2">
      <select [formControl]="pageSizeControl" class="form-select form-select-sm d-inline w-auto">
        @for (pageSize of pageSizeOptions; track pageSize) {
          <option [ngValue]="pageSize">{{ pageSize }}</option>
        }
      </select>
      <span>{{ 'per page' | messageTranslate }}</span>
    </div>
  }

  <div class="pagination-container">
    @if (page != null && (showPagesForSinglePage || ((count / pageSize) > 1))) {
      <ngb-pagination #ngbPagination
                      size="sm"
                      [collectionSize]="count"
                      [page]="page"
                      [pageSize]="pageSizeControl.value"
                      [boundaryLinks]="boundaryLinks"
                      [ellipses]="showEllipsis"
                      [rotate]="rotate"
                      [maxSize]="numberOfPagesDisplayed"
                      (pageChange)="setCurrentPage($event, true)">
        <ng-template ngbPaginationFirst>
          <!-- Hiding first page icon on narrow screens to keep it consistent with ace-table pagination control -->
          <fa-icon class="d-none d-sm-inline-block" icon="backward-step" [fixedWidth]="true"/>
        </ng-template>
        <ng-template ngbPaginationPrevious>
          <fa-icon icon="chevron-left" [fixedWidth]="true"/>
        </ng-template>
        <ng-template ngbPaginationPages let-page let-pages="pages" let-disabled="disabled">
          <!-- Using `$index` for identity tracking because `-1` is used to represent ellipsis-ed page number which can appear twice -->
          <!-- Keep on one line: line breaks render as a space (preserveWhitespaces) -->
          @for (pageNumber of pages; track $index) {<li
            class="page-item d-none d-sm-inline-block"
            [class.active]="pageNumber === page"
            [class.disabled]="pageNumber === NGB_ELLIPSIS_PAGE_NUMBER || disabled"
            [attr.aria-current]="(pageNumber === page ? 'page' : null)">
            @if (pageNumber !== NGB_ELLIPSIS_PAGE_NUMBER) {
              <a class="page-link clickable"
                 [attr.tabindex]="disabled ? '-1' : null"
                 [attr.aria-disabled]="disabled ? 'true' : null"
                 [routerLink]=""
                 (click)="ngbPagination.selectPage(pageNumber)">
                {{ pageNumber }}
              </a>
            }
          </li>}
        </ng-template>
        <ng-template ngbPaginationNext>
          <fa-icon icon="chevron-right" [fixedWidth]="true"/>
        </ng-template>
        <ng-template ngbPaginationLast>
          <!-- Hiding last page icon on narrow screens to keep it consistent with ace-table pagination control -->
          <fa-icon class="d-none d-sm-inline-block" icon="forward-step" [fixedWidth]="true"/>
        </ng-template>
      </ngb-pagination>
    }
  </div>

  @if (showJumpToPage) {
    <div class="d-none d-md-flex gap-1 form-group mb-0 align-items-center ps-4">
      <label for="paginationInput" class="mb-0 form-label">{{ 'Jump to page' | messageTranslate }}</label>
      <input id="paginationInput"
             #jumpToPageInput
             class="form-control form-control-sm d-inline page-number"
             type="text"
             inputmode="numeric"
             pattern="[0-9]*"
             aria-labelledby="paginationInputLabel paginationDescription"
             [value]="page"
             (blur)="jumpToPage(jumpToPageInput.value)"
             (keyup.enter)="jumpToPage(jumpToPageInput.value)"/>
    </div>
  }
</div>
